import renderTimini from "./react_renderer";
import initializeToasts from "./banto_ui";

initializeToasts();
renderTimini();
